import type { SubmitErrorHandler } from 'react-hook-form';
import type { HostKind } from '#util/host.ts';
import type { HostFormData } from '../host-form-schema.ts';
import { useHostTabs } from './useHostTabs.ts';

/**
 * {@link useFocusTabWithErrors} will look through the current errors and switch the current tab
 * if necessary (there are no errors on the current tab)
 */
export function useFocusTabWithErrors(hostType: HostKind) {
  const { tab, setTab } = useHostTabs();

  const focusTabWithErrors: SubmitErrorHandler<HostFormData> = (errors) => {
    // Switch to the tab that has errors if the current one doesn't.
    const hasGeneralErrors = Boolean(
      Object.entries(errors).filter(
        ([key]) => key !== 'configOverrides' && !key.startsWith('root') && (hostType !== 'host' || key !== 'listenPort')
      ).length
    );

    const hasAdvancedErrors = Boolean(errors.configOverrides) || (hostType === 'host' && errors.listenPort);

    if (hasGeneralErrors && !hasAdvancedErrors && tab !== 'general') {
      return setTab.general();
    }

    if (hasAdvancedErrors && !hasGeneralErrors && tab !== 'advanced') {
      return setTab.advanced();
    }
  };

  return focusTabWithErrors;
}
